module.exports = __webpack_public_path__ + "static/media/il-porfolio@3x.a390756e.png";